import { z } from "zod";

import type { DbEntity } from "../../../../client";

/**
 * Shared response schemas used across multiple endpoints
 */

/**
 * Base document response schema
 * Used for single document responses and in arrays
 */
export const DocumentResponseSchema = z.custom<DbEntity.Document>(
  (data): data is DbEntity.Document => {
    // Validate critical fields exist
    return (
      typeof data === "object" &&
      data !== null &&
      "id" in data &&
      typeof data.id === "string" &&
      "name" in data &&
      typeof data.name === "string"
    );
  },
  {
    message: "Invalid document response: missing required fields"
  }
);

/**
 * Document list response with pagination
 */
export const DocumentListResponseSchema = z.object({
  documents: z.array(
    z.custom<DbEntity.Document>((data) => typeof data === "object" && data !== null && "id" in data)
  ),
  total: z.number().int().min(0)
});
